import mixpanel from "mixpanel-browser";
import _ from 'lodash';
import { postEvent } from "~/services/mixpanelServices";
import { version } from '../../package.json';

const mixpanelTokenNew = process.env.REACT_APP_MIXPANEL_TOKEN_NEW;

export const getCountryName = (b) => {
  if (b?.phone?.startsWith('+1')) {
    return 'Estados Unidos';
  } else if (b?.phone?.startsWith('+31')) {
    return 'Holanda';
  } else if (b?.phone?.startsWith('+33')) {
    return 'França';
  } else if (b?.phone?.startsWith('+34')) {
    return 'Espanha';
  } else if (b?.phone?.startsWith('+39')) {
    return 'Itália';
  } else if (b?.phone?.startsWith('+44')) {
    return 'Reino Unido';
  } else if (b?.phone?.startsWith('+51')) {
    return 'Peru';
  } else if (b?.phone?.startsWith('+52')) {
    return 'México';
  } else if (b?.phone?.startsWith('+54')) {
    return 'Argentina';
  } else if (b?.phone?.startsWith('+56')) {
    return 'Chile';
  } else if (b?.phone?.startsWith('+57')) {
    return 'Colômbia';
  } else if (b?.phone?.startsWith('+91')) {
    return 'Índia';
  } else if (b?.phone?.startsWith('+244')) {
    return 'Angola';
  } else if (b?.phone?.startsWith('+245')) {
    return 'Guiné-Bissau';
  } else if (b?.phone?.startsWith('+351')) {
    return 'Portugal';
  } else {
    return 'Brasil';
  }
};

export const mixpanelInitialize = () => {
  try {
    mixpanel.init(mixpanelTokenNew, { debug: true, autotrack: false, ip: false }, 'new');
    mixpanel.new.reset();
  } catch (err) {
    console.log(err);
  }
};

const  getOS = () => {
  const userAgent = navigator.userAgent;
  if (/Windows NT/.test(userAgent)) {
    return "windows";
  } else if (/Mac OS X|Macintosh/.test(userAgent)) {
    return "ios";
  } else if (/Android/.test(userAgent)) {
    return "android";
  } else if (/Linux/.test(userAgent)) {
    return "linux";
  } else if (/iPhone|iPad/.test(userAgent)) {
    return "ios";
  } else if (/CrOS/.test(userAgent)) {
    return "chrome";
  }
  return "Sistema operacional desconhecido";
}

const unsetArray = [
  "$name", "$Name", "name", "Name",
  "$email", "$email", "email", "Email",
  "$phone", "$Phone", "phone", "Phone",
  "$so", "$So", "$SO", "So", "so",
  "$Último acesso",
  "$Baixou qual app",
  "$Admin", "$admin",
  "$userEntity", "$UserEntity", "UserEntity",
  "$País", "$Pais",
  "Qual_É_O_App",
];

export const mixpanelUserInitialize = (user = {}, event = '', eventProps = {}, sendApi = false) => {
  if (!_.isEmpty(user)) {
    try {
      if (user?.id) {
        mixpanel.new.identify(`u-${user?.id || ''}`);
        unsetArray.forEach(property => {
          mixpanel.new.people.unset(property);
        });
        mixpanel.new.people.set({
          "Name": user?.name || 'Sem nome',
          "Email": user?.email || 'Sem email',
          "Phone": user?.phone || user?.phoneNumber || user?.phoneUnverified || 'Sem telefone',
          "Client": true,
          "User_Entity": true,
          "SO": getOS(),
          "Ultimo_Acesso": new Date().toString(),
          "Pais": getCountryName(user),
        });
        mixpanel.new.register({
          "Name": user?.name || 'Sem nome',
          "Email": user?.email || 'Sem email',
          "Phone": user?.phone || user?.phoneNumber || user?.phoneUnverified || 'Sem telefone',
          "Client": true,
          "User_Entity": true,
          "SO": getOS(),
          "Ultimo_Acesso": new Date().toString(),
          "Pais": getCountryName(user),
          "Qual_Aplicacao": 'Web_Consumidor',
          "Versao_Web_Consumidor": version,
        });
        if (!_.isEmpty(event)) {
          mixpanel.new.track(event, eventProps);
          if (sendApi) {
            postEvent({message: event, business_id: '', user_id: user?.id || ''});
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }
};

export const mixpanelTrackEvent = (event = '', eventProps = {}, sendUser = {}, sendBusiness = {}, sendApi = false) => {
  try {
    const shouldTrackUser = !_.isEmpty(sendUser) && !_.isEmpty(sendUser?.id);
    const shouldTrackBusiness = !_.isEmpty(sendBusiness) && !_.isEmpty(sendBusiness?.id);
    const props = { "Versao_Web_Consumidor": version, ...eventProps };

    if (shouldTrackUser && shouldTrackBusiness) {
      mixpanel.new.identify(`u-${sendUser.id}`);
      mixpanel.new.add_group("company_id", sendBusiness.id);
      mixpanel.new.track_with_groups(event, props, { "company_id": sendBusiness.id });

    } else if (shouldTrackUser) {
      mixpanel.new.identify(`u-${sendUser?.id || ''}`);
      mixpanel.new.track(event, props);

    } else if (shouldTrackBusiness) {
      mixpanel.new.add_group("company_id", sendBusiness.id);
      mixpanel.new.track_with_groups(event, props, { "company_id": sendBusiness.id });

    } else {
      mixpanel.new.track(event, props);
    }

    if (sendApi) {
      postEvent({message: event, business_id: sendBusiness?.id || '', user_id: sendUser?.id || ''});
    }
  } catch (err) {
    console.log(err);
  }
};